import promptData from "../../data/prompt-examples.json"

interface PromptHighlighterProps {
  text: string
}

export function PromptHighlighter({ text }: PromptHighlighterProps) {
  if (!text) return <span>&nbsp;</span>

  const { keywords } = promptData

  // Build regex matchers
  const regexEscape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  const withBoundaries = (w: string) => (/^[A-Za-z]+$/.test(w) ? `\\b${regexEscape(w)}\\b` : regexEscape(w))
  const makeMatches = (words: string[]) => new RegExp(words.map(withBoundaries).join("|"), "gi")

  // Create array marking each char type
  const charTypes: ("neutral" | "buy" | "sell" | "action")[] = Array(text.length).fill("neutral")
  let buyHighlighted = false

  // Mark matches
  const markMatches = (regex: RegExp, type: "buy" | "sell" | "action") => {
    for (const match of text.matchAll(regex)) {
      if (type === "buy" && buyHighlighted) continue
      const start = match.index ?? 0
      const end = start + match[0].length
      for (let i = start; i < end; i++) {
        charTypes[i] = type
      }
      if (type === "buy") buyHighlighted = true
    }
  }

  markMatches(makeMatches(keywords.buy), "buy")
  markMatches(makeMatches(keywords.sell), "sell")
  markMatches(makeMatches(keywords.action), "action")

  const transitionCls = "transition-colors duration-75"

  return (
    <>
      {text.split("").map((ch, idx) => {
        if (ch === " ") return " "

        const t = charTypes[idx]
        let cls = transitionCls

        switch (t) {
          case "buy":
            cls += " text-[#22FF65]/96 font-semibold"
            break
          case "sell":
            cls += " text-[#FF2D55]/96 font-semibold"
            break
          case "action":
            cls += " text-[#30DDFF]/96 font-semibold"
            break
          default:
            cls += " text-white/50"
        }

        return (
          // biome-ignore lint/suspicious/noArrayIndexKey: Character highlighting requires positional keys - same char can appear multiple times
          <span key={`char-${ch}-${idx}`} className={cls}>
            {ch}
          </span>
        )
      })}
    </>
  )
}
